module.exports = __webpack_public_path__ + "static/media/Hospitality_13.58ca1cf4.jpg";